/* @flow */

import { assertObject, assertArray } from '@braindate/util/lib/assert';
import { isNumber } from '@braindate/util/lib/type';

import type { Keyword } from 'src/shared/domain/keyword/type/keywordTypes';

/*
 |------------------------------------------------------------------------------
 | Assertions
 |------------------------------------------------------------------------------
 */

export function assertKeyword(keyword: Keyword): void {
  assertObject(keyword, 'keyword');
}

/*
 |------------------------------------------------------------------------------
 | Getters
 |------------------------------------------------------------------------------
 */

export function getKeywordLabel(keyword: Keyword): string {
  assertKeyword(keyword);

  return keyword.label;
}

export function getKeywordTopicCount(keyword: Keyword): ?number {
  assertKeyword(keyword);

  return keyword.count;
}

export function getKeywordInterestCount(keyword: Keyword): ?number {
  assertKeyword(keyword);

  return keyword.interests_count;
}

export function getKeywordLanguage(keyword: Keyword): ?string {
  assertKeyword(keyword);

  return keyword.language;
}

export function getKeywordEnabled(keyword: Keyword): ?boolean {
  assertKeyword(keyword);

  return keyword.enabled;
}

/*
 |------------------------------------------------------------------------------
 | Other
 |------------------------------------------------------------------------------
 */

export function getKeywordsTotalTopicCount(keywords: Array<Keyword>): number {
  assertArray(keywords, 'keywords');

  return keywords.reduce((acc, keyword) => {
    const topicCount = getKeywordTopicCount(keyword);

    if (isNumber(topicCount)) {
      return acc + topicCount;
    }

    return acc;
  }, 0);
}
